import { TaskChartMetric } from "./ChartConstants";
/**
 * Possible task grouping types supported in the application
 */ export var TaskGroupingState = /*#__PURE__*/ function(TaskGroupingState) {
    /** No grouping is applied */ TaskGroupingState[TaskGroupingState["None"] = 0] = "None";
    /** Tasks are grouped by assignees */ TaskGroupingState[TaskGroupingState["Assignee"] = 1] = "Assignee";
    /** Tasks are grouped by buckets */ TaskGroupingState[TaskGroupingState["Bucket"] = 2] = "Bucket";
    /** Tasks are grouped by plans */ TaskGroupingState[TaskGroupingState["Plan"] = 3] = "Plan";
    /** Tasks are grouped by progress */ TaskGroupingState[TaskGroupingState["Progress"] = 4] = "Progress";
    /** Tasks are grouped by due date */ TaskGroupingState[TaskGroupingState["DueDate"] = 5] = "DueDate";
    /** Tasks are grouped by category */ TaskGroupingState[TaskGroupingState["Category"] = 6] = "Category";
    /** Tasks are grouped by priority */ TaskGroupingState[TaskGroupingState["Priority"] = 7] = "Priority";
    /** Tasks are grouped by Project Manager State */ TaskGroupingState[TaskGroupingState["ProjectManagerWorkflowState"] = 8] = "ProjectManagerWorkflowState";
    return TaskGroupingState;
}({});
/**
 * Possible task grouping options supported in the Evo application
 * Note 1: The values are minimal to minimize stored size as these go onto extensions
 * Note 2: Since this is serialized data, we cannot change the values without breaking existing data. Please only append new values.
 */ export var TaskGroupingOption = /*#__PURE__*/ function(TaskGroupingOption) {
    /** No grouping is applied */ TaskGroupingOption["None"] = "n";
    /** Tasks are grouped by assignees */ TaskGroupingOption["Assignee"] = "a";
    /** Tasks are grouped by buckets */ TaskGroupingOption["Bucket"] = "b";
    /** Tasks are grouped by plans */ TaskGroupingOption["Plan"] = "p";
    /** Tasks are grouped by status */ TaskGroupingOption["Status"] = "s";
    /** Tasks are grouped by due date */ TaskGroupingOption["DueDate"] = "d";
    /** Finish Date */ TaskGroupingOption["FinishDate"] = "f";
    /** Tasks are grouped by start date */ TaskGroupingOption["StartDate"] = "sd";
    /** Tasks are grouped by category */ TaskGroupingOption["Category"] = "c";
    /** Tasks are grouped by priority */ TaskGroupingOption["Priority"] = "pr";
    /** Tasks are grouped by Project Manager Workflow State */ TaskGroupingOption["ProjectManagerWorkflowState"] = "pm";
    /** Tasks are grouped by goals */ TaskGroupingOption["Goal"] = "g";
    /** Tasks are grouped by source (shared / personal / private) */ TaskGroupingOption["Source"] = "so";
    return TaskGroupingOption;
}({});
/**
 * Supported task grouping options for Evo Plan Views
 */ export const SupportedPlanTaskGroupingOptions = [
    "pm",
    "a",
    "b",
    "c",
    "sd",
    "d",
    "f",
    "pr",
    "s",
    "g"
];
/**
 * Supported task grouping options for Evo Personal Views
 */ export const SupportedPersonalTaskGroupingOptions = [
    "d",
    "p",
    "pr",
    "s"
];
/**
 * Task grouping options for Plan
 */ export const PlanTaskGroupingOptions = [
    2,
    1,
    4,
    5,
    6,
    7
];
/** Task grouping options for Plan with Project Manager */ export const PlanTaskGroupingOptionsWithProjectManager = [
    8
].concat(PlanTaskGroupingOptions);
/**
 * Task grouping options for Assigned To User
 */ export const AssignedToUserTaskGroupingOptions = [
    3,
    4,
    5,
    7
];
/** Task grouping options for Assigned To User with Project Manager */ export const AssignToUserTaskGroupingOptionsWithCopilot = [
    8
].concat(AssignedToUserTaskGroupingOptions);
// Empty task charts metrics for charts with no data, default in case store data has not loaded yet
export const EmptyTaskChartMetrics = {
    [TaskChartMetric.Late]: 0,
    [TaskChartMetric.NotStarted]: 0,
    [TaskChartMetric.InProgress]: 0,
    [TaskChartMetric.Completed]: 0,
    [TaskChartMetric.Blocked]: 0
};
// Group id for tasks that are not bucketed
export const UnbucketedTaskGroup = "unbucketed";
// Group id for tasks that have no goal association
export const TasksWithoutGoalAssociationGroup = "taskswithoutgoalassociation";
// Group id for tasks that have no assignee
export const UnassignedTaskGroup = "unassigned";
// Group id for tasks that have no labels
export const UnlabelledTaskGroup = "unlabelled";
// Group id for tasks that have no custom field value for the grouping custom field
export const TasksWithoutCustomFieldValueGroup = "taskswithoutcustomfieldvalue";
// Group id for tasks whose Flag custom field value is set to true ("Yes")
export const CustomFieldFlagYesGroup = "customfieldflagyes";
// Group id for tasks whose Flag custom field value is set to false ("No")
export const CustomFieldFlagNoGroup = "customfieldflagno";
/** Prefix for custom field grouping option IDs to avoid collision with built-in TaskGroupingOption values */ export const CUSTOM_FIELD_GROUPING_OPTION_PREFIX = "cfGroup_";
// Group id for that contains all tasks
export const AllTasksGroup = "all";
// Source grouping keys
export const SharedSourceGroup = "shared";
export const PersonalSourceGroup = "personal";
export const PrivateSourceGroup = "private";
/**
 * Group id that coalesces every backing plan of Private Tasks into one user-facing group.
 *
 * Private Tasks is dual-source (the legacy To Do default plan and the Planner Default Plan), so tasks from
 * either source group under this key. It is the shared vocabulary between the store, which emits it, and the
 * views, which render and order by it, so neither side has to know which plan currently backs Private Tasks.
 */ export const PrivateTasksVirtualGroupKey = "privateTasks";
